import KanaGrid from "@/components/app/KanaGrid";
import { useLang } from "@/context/LanguageContext";
export default function KatakanaPage() {
  const { t } = useLang();
  return <KanaGrid system="katakana" title={`${t("katakana")} カタカナ`} subtitle={t("kataSubtitle")} chartLabel={t("kataChart")} />;
}
